class LoginController {
  constructor(User, $rootScope, $window, AuthFactory, $state, $translate) {
    "ngInject";
    const vm = this;

    vm.rootScope = $rootScope;

    /* init loginModel */
    vm.$onInit = () => {
      vm.loginModel = {
        username: "",
        password: "",
        type: AuthFactory.USER_TYPES.USER,
      };
    };

    /* Language */
    vm.vLanguage = "en";
    if ($window.localStorage.getItem("vLanguage")) {
      vm.vLanguage = $window.localStorage.getItem("vLanguage");
      $translate.use(vm.vLanguage);
    }

    vm.changeLanguage = (key) => {
      vm.vLanguage = key;
      $translate.use(key);
      $window.localStorage.setItem("vLanguage", key);
      $window.location.reload();
    };

    vm.login = () => {
      AuthFactory.login(vm.loginModel, vm.loginModel.type)
        .then((response) => {
          if (response.data.token) {
            vm.rootScope.isUserLoggedIn = true;
            vm.rootScope.token = response.data.token;
            $window.localStorage.setItem("token", response.data.token);
            $window.localStorage.setItem(
              "user",
              JSON.stringify(response.data.user)
            );
            vm.rootScope.user = User.build(response.data.user);
            vm.rootScope.currentUser = JSON.parse(
              $window.localStorage.getItem("user")
            );
            $state.go("dashboard");
          }
        })
        .catch((error) => {
          vm.rootScope.isUserLoggedIn = false;
          delete $window.localStorage.token;
          delete $window.localStorage.user;
        });
    };
  }
}

export default LoginController;



// WEBPACK FOOTER //
// ./client/app/components/auth/login/login.controller.js